<template>
  <div class="job-card" ref="jobCardContainer">
    <img v-if="jobItem.jobTitle" :src="profileImage" 
    @error="setDefaultImage"
    alt="Company logo"
     class="logo" />
    <div class="details">
       <div class="company">
        
        <div class="job-title">
          {{ jobItem.jobTitle || 'No jobs are currently available yet.' }}  
        </div>
        <div class="company-name">
          {{ jobItem.name }}
        </div>
      </div>
      <div v-if="jobItem.jobTitle" class="type job-detail">
        <BriefcaseJobIcon class="job-icon"/><div class="detail">{{ jobItem.jobType || '--' }}</div>
      </div>
      <div v-if="jobItem.jobTitle" class="location job-detail">
        <PinIcon class="job-icon"/><div class="detail">{{ jobItem.location }}</div> 
      </div>
      
      <div v-if="jobItem.jobTitle" class="closing-date job-detail">
        <CalendarIcon class="job-icon"/> <div class="detail">{{ jobItem.closingDate }}</div>
      </div>
      <button v-if="jobItem.jobTitle" @click="copyLink(jobItem.encodedJobId)" class="btn btn-default btn-sm copy-btn">
        <CopyIcon class="copy-icon"/>
        <div class="copy-text">
          {{ isCopied ? 'Copied!' : 'Copy Link' }}
        </div>
      </button>
      <div class="description" v-html="formattedDescription(jobItem.description)"></div>
      

      <!-- Buttons container -->
      <div v-if="jobItem.jobTitle" class="actions">
        <button class="btn btn-default apply-btn" @click="apply">Apply</button>
        <button class="btn btn-default save-btn" :disabled="saving"  @click="saveJob">{{ saveBtnLabel }}</button>
      </div>
    </div>
  </div>
  <ApplyToJobModal ref="applyJob" modal-id="applyToJob"/>
  <CustomConfirmationMessageModal :title="modal.caption"
            ref="saveJobModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
  <ToastMessage ref="jobPreviewToast"
           :message="toast.message"
           :success="toast.success"/>
</template>

<script>
  import Modal from 'bootstrap/js/dist/modal'
  import ApplyToJobModal from '../modals/ApplyToJobModal.vue';
  import { ToggleSaveJobAsync } from '@/services/public/vacancyService';
import { auth } from '@/store/auth/auth';
import CustomConfirmationMessageModal from '../modals/CustomConfirmationMessageModal.vue';
import BriefcaseJobIcon from '../IconComponents/BriefcaseJobIcon.vue';
import PinIcon from '../IconComponents/PinIcon.vue';
import CalendarIcon from '../IconComponents/CalendarIcon.vue';
import CopyIcon from '../IconComponents/CopyIcon.vue';
import DOMPurify from 'dompurify'
import ToastMessage from '../modals/ToastMessage.vue';
export default {
  components:{
    ApplyToJobModal, 
    CustomConfirmationMessageModal,
    BriefcaseJobIcon,
    PinIcon,
    CalendarIcon,
    CopyIcon,
    ToastMessage
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    updateJobIsSavedStatus:{
      type: Function,
      required: false
    },
    hidePreviewVacancyModal:{
      type: Function,
      required: false
    }

  },
  watch:{
    job:{
      handler(newValue){
        this.jobItem = newValue;
        if(this.jobItem.isSaved == true){
          this.saveBtnLabel = "Unsave"
        }else{
          this.saveBtnLabel = "Save"
        }

        this.$refs.jobCardContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      deep: true,
      immediate: false
    } 
  },
  data(){
    return{
      //confirmModalInstance: null,
      url:process.env.VUE_APP_API_URL,
      site_url: process.env.VUE_APP_SITE_URL,
      jobItem:{},
      saveBtnLabel : "Save",
      saving: false,
       modal:{
                caption:"",
                message:""
            },
            modalButtonLabel:'Close',
            modalId:"saveJobPrev",
      isCopied: false,
      toast:{
        message:"",
        success:true
      }
    }
  },
  computed:{
    profileImage(){
      return this.url + 'Auth/Image/' + this.jobItem.id;
    },
    authUser(){
      return this.$store.getters['auth/getAuthenticatedUser'] || null;
    }
  },
  methods:{
    hidePreviewModal(){
      
      //hide mobile job preview modal
      if(window.innerWidth <= 768){
       
        if(this.hidePreviewVacancyModal != null && typeof this.hidePreviewVacancyModal === "function"){
        
          this.hidePreviewVacancyModal();
        }
      }
    },
    showToastMessage(){
             this.$nextTick(() => {
                    if(this.$refs.jobPreviewToast != null){
                        this.$refs.jobPreviewToast.show();
                    }
                });
    },
    async copyLink(jobId){
      let url = `${window.location.origin}/jobpost/${jobId}`
     
      // Check if the modern Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url)
        this.showSuccess()
      } catch (err) {
        
        this.fallbackCopy(url);
      }
    } else {
      // Fallback for insecure raw IP addresses (HTTP)
      this.fallbackCopy(url);
    }
    },

    fallbackCopy(textToCopy) {
    // Create a temporary hidden textarea element
    const textArea = document.createElement('textarea')
    textArea.value = textToCopy
    
    // Avoid scrolling to the bottom of the page when appending
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select() // Highlight the text inside

    try {
      // Execute the legacy copy command
      const successful = document.execCommand('copy')
      if (successful) {
        this.showSuccess()
      } else {
        alert('Unable to copy link.')
      }
    } catch (err) {
      alert('Oops, unable to copy!')
    }

    // Clean up by removing the element from the DOM
    document.body.removeChild(textArea)
  },

  showSuccess(){
    this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      },3000);
  },
    async saveJob(){
      try{
      if(this.canAccess('enterprise')){
        this.logOutToSignUp();
        return;
    }
      this.saveBtnLabel = "Saving...";
      this.saving = true;
       var response = await ToggleSaveJobAsync(this.jobItem.jobId,this.hidePreviewModal)
            if(!response.success){
                this.saveBtnLabel = "Save";
                this.saving = false;
                const err = new Error(response.message, {reason: response.caption});
                err.caption = response.caption;
                throw err;          
                }else{
                  this.updateJobIsSavedStatus(this.jobItem, response.isSaved); //update main collection
                  this.saveBtnLabel = response.isSaved == true ? "Unsave" : "Save"; //if is saved, indicate Unsave Label
                  this.saving = false;
                  // this.modal.caption = "Vacancy";
                  // this.modal.message = response.message;
                  // this.showModal();   
                  this.toast.message = response.message;
                  this.toast.success = true;
                  this.showToastMessage();
            }
          }catch(e){
            this.saveBtnLabel = "Save";
            this.saving = false;
            // this.modal.caption = e.reason;
            // this.modal.message = e.message;
            // this.showModal(); 
            let message = e.message === "Failed to fetch" ? "Unable to update save status of this job. Check your internet connection and try again." : e.message;
            this.toast.message = message;
            this.toast.success = false;
            this.showToastMessage();
          }
    },
    apply(){
    if(this.canAccess('enterprise')){
        //logged out if logged in as other user to sign up for another account
        //should work even if no log in session is present
        this.logOutToSignUp();
        return;

    }
    this.$refs.applyJob.setVacancyDetails(this.jobItem);
     this.$refs.applyJob.show();
    },
    closeModal(){
       if (this.$refs.saveJobModal && typeof this.$refs.saveJobModal.hide === 'function') {
        this.$refs.saveJobModal.hide();
        }    
    },
     showModal(){
            this.$refs.saveJobModal.show();
        },
    danger(){
       //this.confirmModalInstance2.show();
    },
logOutToSignUp(){
            this.$store.dispatch('auth/logout');
            if(this.hidePreviewVacancyModal != null && typeof this.hidePreviewVacancyModal === 'function'){
              if(window.innerWidth <= 768){
                 this.hidePreviewVacancyModal();
              }
            }
            this.$router.push({path:'/login',
                          query: {
                            message: "You have to log in first"
                          }});
        },
    send(){
      
    },
    setDefaultImage(event) {
      event.target.src = require('@/assets/images/profile_picture.png');
    },
     formattedDescription(description) {
  if (!description) return '';

  // 1. Sanitize raw input (Strips XSS + <img> tags)
  let updated = DOMPurify.sanitize(description, { FORBID_TAGS: ['img'] });

  // 2. Convert <ol> tags into <ul> tags (and strip list type attributes)
  updated = updated.replace(/<ol(\s[^>]*)?>/gi, '<ul>');
  updated = updated.replace(/<\/ol>/gi, '</ul>');

  // 3. Strip existing inline background-color from user input
  updated = updated.replace(/background-color:\s*[^;"]+;?/gi, '');

  // 4. Strip existing inline text color from user input
  updated = updated.replace(/color:\s*[^;"]+;?/gi, '');

  // 5. Inject your custom theme styles into <p> tags safely
  updated = updated.replace(
    /<p(\s[^>]*)?>/g,
    '<p$1 style="background-color:transparent;color:var(--foreground);padding:0rem;border-radius:0px;margin-bottom:1rem;">'
  );

  // 6. Remove empty paragraphs
  updated = updated.replace(/<p[^>]*><br><\/p>/g, '');

  return updated;
},
    
        canAccess(routeName) {
          if(this.authUser != null){
          // Resolve the route by name. `resolved.matched` contains the matched route records.
          const resolved = this.$router.resolve({ name: routeName })
          // Use the most-specific matched record (last entry) so child route meta is respected.
          const matched = resolved?.matched || []
          if (!matched.length) return false // route not found
          const record = matched[matched.length - 1]
          const meta = record.meta || {}
          // Read token from localStorage (used by guards elsewhere in the app).
          const token = localStorage.getItem('token')
          // Prefer the `authUser` from the Vuex store. Fall back to the `user` stored in localStorage.
          let user = this.authUser.value
          if (!user) {
            try {
              user = JSON.parse(localStorage.getItem('user'))
            } catch (e) {
              user = null
            }
          }
          // If the route requires authentication and there's no token, deny access.
          if (meta.requiresAuth && !token) {
            return false
          }
          // If the route specifies allowed roles, check the user's role in multiple possible shapes:
          //  - user.roles: an array of role strings
          //  - user.userType: a single role stored under `userType` (used in signup)
          //  - user.role: another common single-role field
          if (meta.roles) {
            let hasRole = false
            if (Array.isArray(user?.roles)) {
              hasRole = user.roles.some(role => meta.roles.includes(role))
            } else if (user?.userType) {
              hasRole = meta.roles.includes(user.userType)
            } else if (user?.role) {
              hasRole = meta.roles.includes(user.role)
            }
            if (!hasRole) return false
          }
          // No checks failed — allow access.
          return true;
        }else{
          return true;
        }
      }
  }
};
</script>

<style scoped>


.copy-icon{
  color:var(--darkgrey3);
  height:1rem;
}

.copy-text{
  color:var(--darkgrey3);
  font-family:var(--body-font);
  font-size:0.8rem;
}

.copy-btn{
  display: flex;
  align-items: center;
  column-gap:0.3rem;
  background-color: var(--background);
  border-radius: 8px;
  margin-top:0.8rem;
  margin-bottom:1rem;
  
}

.job-title{
   font-family: var(--job-title-font);
   font-size:1.3rem;
   color:var(--job-title);
   white-space:wrap;

}

.company-name{
  font-family: var(--heading-font-bold);
  font-size:0.9rem;
  margin-bottom:0.4rem;
  white-space:wrap;
}

.job-detail{
  display: flex;
  align-items: center;
  color:var(--darkgrey3);
}



.detail{
  font-family: var(--body-font);
  font-size:0.9rem;
  
}

.job-icon{
  height:1rem;
  margin-right:0.4rem;
  margin-top:-0.2rem;
  color:var(--darkgrey3);
}



.job-card {
  display: flex;
  flex-direction: column; /* stack vertically */
  align-items: flex-start; /* keep everything left-aligned */
  padding: 1rem;
  border-radius: 6px;
  /* margin-bottom: 1rem; */
  margin-right:0.5rem;
  background-color: var(--list-item);
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem; /* space below image */
  border-radius: 4px;
  object-fit: cover;
  align-self: flex-start; /* force logo to left */
}

.details {
  width: 100%;
}

.details h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.description {
  white-space: pre-line;
  margin-top:1rem;
  margin-bottom: 0.5rem;
  font-family: var(--body-font);
}








/* Buttons container */
.actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem; /* space between buttons */
}

/* Apply button styling */
.apply-btn {
  padding: 0.5rem 1rem;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  border-radius: 8px;
}



/* Save button styling */
.save-btn {
  padding: 0.5rem 1rem;
  background-color: #b121d156;
  color: white;
  border: none;
  border-radius: 4px;
  /* font-weight: bold; */
  cursor: pointer;
  border-radius: 8px;
}



.location, .type, .closing-date{
  font-family: var(--heading-font2-regular);
}

/* Larger screens */
@media (max-width: 768px) {
  .job-card {
    align-items: flex-start; /* keep left alignment even on desktop */
    margin-left:0rem;
    background-color: var(--modal-background);
  }

  .description {
  margin-top:0.5rem;
  line-height:1.1rem;
  font-size:0.9rem;
  
  }

  .location, .type, .closing-date{
   font-size:0.9rem;
}

  .company{
    font-size:1.2rem;
  }
}
</style>